webpackJsonp([236594062348235],{

/***/ 117:
/***/ (function(module, exports) {

	module.exports = [{"title":"Installation","items":[{"id":"getting-started","title":"Getting Started"}]},{"title":"Reference","items":[{"id":"components","title":"Components"},{"id":"props","title":"Props"},{"id":"data-api","title":"Data API"},{"id":"state-management","title":"State Management"},{"id":"pub-sub","title":"Pub/Sub Emitter"}]},{"title":"Customization","items":[{"id":"override-components","title":"Override Components"},{"id":"custom-components","title":"Custom Components"},{"id":"root-components","title":"Root Components"}]}]

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(51);
	var isArguments = __webpack_require__(50);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 50:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 51:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 115:
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(57);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(49);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(55);
	
	var _HelmetConstants = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(15);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(52);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(58);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),

/***/ 58:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 536:
/***/ (function(module, exports, __webpack_require__) {

	
	;(function (name, root, factory) {
	  if (true) {
	    module.exports = factory()
	  }
	  /* istanbul ignore next */
	  else if (typeof define === 'function' && define.amd) {
	    define(factory)
	  }
	  else {
	    root[name] = factory()
	  }
	}('slugify', this, function () {
	  /*eslint-disable */
	  var charMap = JSON.parse('{"$":"dollar","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","џ":"dz","Ґ":"G","ґ":"g","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","‘":"\'","’":"\'","“":"\\\"","”":"\\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₹":"indian rupee","₽":"russian ruble","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial"}')
	  /*eslint-enable */
	
	  function replace (string, options) {
	    options = (typeof options === 'string')
	      ? {replacement: options}
	      : options || {}
	
	    string = string.split('')
	      .reduce(function (result, ch) {
	        if (charMap[ch]) {
	          ch = charMap[ch]
	        }
	        // allowed
	        ch = ch.replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]/g, '')
	        result += ch
	        return result
	      }, '')
	      // trim leading/trailing spaces
	      .replace(/^\s+|\s+$/g, '')
	      // convert spaces
	      .replace(/[-\s]+/g, options.replacement || '-')
	      // remove trailing separator
	      .replace('#{replacement}$', '')
	
	    return options.lower ? string.toLowerCase() : string
	  }
	
	  replace.extend = function (customMap) {
	    for (var key in customMap) {
	      charMap[key] = customMap[key]
	    }
	  }
	
	  return replace
	}))


/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
	                                                                                                                                                                                                                              * Copyright (c) 2013-present, Facebook, Inc.
	                                                                                                                                                                                                                              *
	                                                                                                                                                                                                                              * @emails react-core
	                                                                                                                                                                                                                              * 
	                                                                                                                                                                                                                              */
	
	/**
	 * Convenience component for declaring a flexbox layout.
	 */
	var Flex = function Flex(_ref) {
	  var _ref$basis = _ref.basis,
	      basis = _ref$basis === undefined ? 'auto' : _ref$basis,
	      children = _ref.children,
	      _ref$direction = _ref.direction,
	      direction = _ref$direction === undefined ? 'row' : _ref$direction,
	      _ref$grow = _ref.grow,
	      grow = _ref$grow === undefined ? 0 : _ref$grow,
	      _ref$halign = _ref.halign,
	      halign = _ref$halign === undefined ? 'flex-start' : _ref$halign,
	      _ref$shrink = _ref.shrink,
	      shrink = _ref$shrink === undefined ? 1 : _ref$shrink,
	      _ref$type = _ref.type,
	      type = _ref$type === undefined ? 'div' : _ref$type,
	      _ref$valign = _ref.valign,
	      valign = _ref$valign === undefined ? 'flex-start' : _ref$valign,
	      rest = _objectWithoutProperties(_ref, ['basis', 'children', 'direction', 'grow', 'halign', 'shrink', 'type', 'valign']);
	
	  return (0, _react.createElement)(type, _extends({
	    css: {
	      display: 'flex',
	      flexDirection: direction,
	      flexGrow: grow,
	      flexShrink: shrink,
	      flexBasis: basis,
	      justifyContent: direction === 'row' ? halign : valign,
	      alignItems: direction === 'row' ? valign : halign
	    }
	  }, rest), children);
	};
	
	exports.default = Flex;
	module.exports = exports['default'];

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Flex = __webpack_require__(39);
	
	var _Flex2 = _interopRequireDefault(_Flex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Flex2.default; /**
	                                   * Copyright (c) 2013-present, Facebook, Inc.
	                                   *
	                                   * @emails react-core
	                                   */

	module.exports = exports['default'];

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * Copyright (c) 2013-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * @emails react-core
	                                                                                                                                                                                                                                                                   * 
	                                                                                                                                                                                                                                                                   */
	
	var _Flex = __webpack_require__(16);
	
	var _Flex2 = _interopRequireDefault(_Flex);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _theme = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MarkdownHeader = function MarkdownHeader(_ref) {
	  var _extends2;
	
	  var title = _ref.title;
	  return Glamor.createElement(
	    _Flex2.default,
	    { type: 'header', halign: 'space-between', valign: 'baseline' },
	    Glamor.createElement(
	      'h1',
	      {
	        css: _extends({
	          color: _theme.colors.dark,
	          marginBottom: 0,
	          marginTop: 40
	        }, _theme.fonts.header, (_extends2 = {}, _extends2[_theme.media.size('medium')] = {
	          marginTop: 60
	        }, _extends2[_theme.media.greaterThan('large')] = {
	          marginTop: 80
	        }, _extends2)) },
	      title
	    )
	  );
	};
	
	exports.default = MarkdownHeader;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MarkdownHeader = __webpack_require__(204);
	
	var _MarkdownHeader2 = _interopRequireDefault(_MarkdownHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MarkdownHeader2.default; /**
	                                             * Copyright (c) 2013-present, Facebook, Inc.
	                                             *
	                                             * @emails react-core
	                                             */

	module.exports = exports['default'];

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _Container = __webpack_require__(13);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Flex = __webpack_require__(16);
	
	var _Flex2 = _interopRequireDefault(_Flex);
	
	var _MarkdownHeader = __webpack_require__(205);
	
	var _MarkdownHeader2 = _interopRequireDefault(_MarkdownHeader);
	
	var _NavigationFooter = __webpack_require__(217);
	
	var _NavigationFooter2 = _interopRequireDefault(_NavigationFooter);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StickyResponsiveSidebar = __webpack_require__(209);
	
	var _StickyResponsiveSidebar2 = _interopRequireDefault(_StickyResponsiveSidebar);
	
	var _TitleAndMetaTags = __webpack_require__(41);
	
	var _TitleAndMetaTags2 = _interopRequireDefault(_TitleAndMetaTags);
	
	var _findSectionForPath = __webpack_require__(223);
	
	var _findSectionForPath2 = _interopRequireDefault(_findSectionForPath);
	
	var _toCommaSeparatedList = __webpack_require__(227);
	
	var _toCommaSeparatedList2 = _interopRequireDefault(_toCommaSeparatedList);
	
	var _theme = __webpack_require__(5);
	
	var _createOgUrl = __webpack_require__(80);
	
	var _createOgUrl2 = _interopRequireDefault(_createOgUrl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MarkdownPage = function MarkdownPage(_ref) {
	  var _ref$authors = _ref.authors,
	      authors = _ref$authors === undefined ? [] : _ref$authors,
	      createLink = _ref.createLink,
	      date = _ref.date,
	      enableScrollSync = _ref.enableScrollSync,
	      ogDescription = _ref.ogDescription,
	      location = _ref.location,
	      markdownRemark = _ref.markdownRemark,
	      sectionList = _ref.sectionList,
	      _ref$titlePostfix = _ref.titlePostfix,
	      titlePostfix = _ref$titlePostfix === undefined ? '' : _ref$titlePostfix;
	
	  var hasAuthors = authors.length > 0;
	  var titlePrefix = markdownRemark.frontmatter.title || '';
	
	  return Glamor.createElement(
	    _Flex2.default,
	    {
	      direction: 'column',
	      grow: '1',
	      shrink: '0',
	      halign: 'stretch',
	      css: {
	        width: '100%',
	        flex: '1 0 auto',
	        position: 'relative',
	        zIndex: 0
	      } },
	    Glamor.createElement(_TitleAndMetaTags2.default, {
	      ogDescription: ogDescription,
	      ogUrl: (0, _createOgUrl2.default)(markdownRemark.fields.slug),
	      title: '' + titlePrefix + titlePostfix
	    }),
	    Glamor.createElement(
	      'div',
	      { css: { flex: '1 0 auto' } },
	      Glamor.createElement(
	        _Container2.default,
	        null,
	        Glamor.createElement(
	          'div',
	          { css: _theme.sharedStyles.articleLayout.container },
	          Glamor.createElement(
	            _Flex2.default,
	            { type: 'article', direction: 'column', grow: '1', halign: 'stretch' },
	            Glamor.createElement(_MarkdownHeader2.default, { title: titlePrefix }),
	            (date || hasAuthors) && Glamor.createElement(
	              'div',
	              { css: { marginTop: 15 } },
	              date,
	              ' ',
	              hasAuthors && Glamor.createElement(
	                'span',
	                null,
	                'by',
	                ' ',
	                (0, _toCommaSeparatedList2.default)(authors, function (author) {
	                  return Glamor.createElement(
	                    'a',
	                    {
	                      css: _theme.sharedStyles.link,
	                      href: author.frontmatter.url,
	                      key: author.frontmatter.name },
	                    author.frontmatter.name
	                  );
	                })
	              )
	            ),
	            Glamor.createElement(
	              'div',
	              { css: _theme.sharedStyles.articleLayout.content },
	              Glamor.createElement('div', {
	                css: [_theme.sharedStyles.markdown],
	                dangerouslySetInnerHTML: { __html: markdownRemark.html }
	              })
	            )
	          ),
	          Glamor.createElement(
	            'div',
	            { css: _theme.sharedStyles.articleLayout.sidebar },
	            Glamor.createElement(_StickyResponsiveSidebar2.default, {
	              enableScrollSync: enableScrollSync,
	              createLink: createLink,
	              defaultActiveSection: (0, _findSectionForPath2.default)(location.pathname, sectionList),
	              location: location,
	              sectionList: sectionList
	            })
	          )
	        )
	      )
	    ),
	    (markdownRemark.frontmatter.next || markdownRemark.frontmatter.prev) && Glamor.createElement(_NavigationFooter2.default, {
	      location: location,
	      next: markdownRemark.frontmatter.next,
	      prev: markdownRemark.frontmatter.prev
	    })
	  );
	}; /**
	    * Copyright (c) 2013-present, Facebook, Inc.
	    *
	    * @emails react-core
	    * 
	    */
	
	exports.default = MarkdownPage;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MarkdownPage = __webpack_require__(206);
	
	var _MarkdownPage2 = _interopRequireDefault(_MarkdownPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MarkdownPage2.default; /**
	                                           * Copyright (c) 2013-present, Facebook, Inc.
	                                           *
	                                           * @emails react-core
	                                           */

	module.exports = exports['default'];

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Container = __webpack_require__(13);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Sidebar = __webpack_require__(220);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _theme = __webpack_require__(5);
	
	var _ChevronSvg = __webpack_require__(124);
	
	var _ChevronSvg2 = _interopRequireDefault(_ChevronSvg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2013-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @emails react-core
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var StickyResponsiveSidebar = function (_Component) {
	  _inherits(StickyResponsiveSidebar, _Component);
	
	  function StickyResponsiveSidebar(props) {
	    _classCallCheck(this, StickyResponsiveSidebar);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this._openNavMenu = function () {
	      _this.setState({ open: !_this.state.open });
	    };
	
	    _this._closeNavMenu = function () {
	      _this.setState({ open: false });
	    };
	
	    _this.state = {
	      open: false
	    };
	    return _this;
	  }
	
	  StickyResponsiveSidebar.prototype.render = function render() {
	    var _ref, _ref2, _ref3, _ref4;
	
	    var open = this.state.open;
	
	    var smallScreenSidebarStyles = {
	      top: 0,
	      left: 0,
	      bottom: 0,
	      right: 0,
	      position: 'fixed',
	      backgroundColor: _theme.colors.white,
	      zIndex: 2,
	      height: '100vh',
	      overflowY: 'auto',
	      WebkitOverflowScrolling: 'touch',
	      pointerEvents: open ? 'auto' : 'none'
	    };
	
	    var smallScreenBottomBarStyles = {
	      display: 'inline-block'
	    };
	
	    var iconOffset = open ? 8 : -4;
	    var menuOpacity = open ? 1 : 0;
	    var menuOffset = open ? 0 : 40;
	
	    // TODO: role and aria props for 'close' button?
	    return Glamor.createElement(
	      'div',
	      null,
	      Glamor.createElement(
	        'div',
	        {
	          style: {
	            opacity: menuOpacity,
	            transition: 'opacity 0.5s ease'
	          },
	          css: (_ref = {}, _ref[_theme.media.lessThan('small')] = smallScreenSidebarStyles, _ref[_theme.media.greaterThan('medium')] = {
	            marginRight: -999,
	            paddingRight: 999,
	            backgroundColor: '#f7f7f7'
	          }, _ref[_theme.media.between('medium', 'sidebarFixed', true)] = {
	            position: 'fixed',
	            zIndex: 2,
	            height: '100%'
	          }, _ref[_theme.media.greaterThan('small')] = {
	            position: 'fixed',
	            zIndex: 2,
	            height: 'calc(100vh - 60px)',
	            overflowY: 'auto',
	            WebkitOverflowScrolling: 'touch',
	            marginRight: -999,
	            paddingRight: 999,
	            backgroundColor: '#f7f7f7',
	            opacity: '1 !important'
	          }, _ref[_theme.media.size('small')] = {
	            height: 'calc(100vh - 40px)'
	          }, _ref[_theme.media.between('medium', 'large')] = {
	            height: 'calc(100vh - 50px)'
	          }, _ref[_theme.media.greaterThan('sidebarFixed')] = {
	            borderLeft: '1px solid #ececec'
	          }, _ref) },
	        Glamor.createElement(
	          'div',
	          {
	            style: {
	              transform: 'translate(0px, ' + menuOffset + 'px)',
	              transition: 'transform 0.5s ease'
	            },
	            css: (_ref2 = {
	              marginTop: 60
	
	            }, _ref2[_theme.media.size('xsmall')] = {
	              marginTop: 40
	            }, _ref2[_theme.media.between('small', 'medium')] = {
	              marginTop: 0
	            }, _ref2[_theme.media.between('medium', 'large')] = {
	              marginTop: 50
	            }, _ref2[_theme.media.greaterThan('small')] = {
	              transform: 'none !important'
	            }, _ref2) },
	          Glamor.createElement(_Sidebar2.default, _extends({ closeParentMenu: this._closeNavMenu }, this.props))
	        )
	      ),
	      Glamor.createElement(
	        'div',
	        {
	          css: (_ref3 = {
	            backgroundColor: _theme.colors.darker,
	            bottom: 44, // iOS Safari's inert "bottom 44px"
	            color: _theme.colors.brand,
	            display: 'none', // gets overriden at small screen sizes
	            cursor: 'pointer',
	            position: 'fixed',
	            right: 20,
	            zIndex: 3,
	            borderRadius: '50%',
	            border: '1px solid rgba(255, 255, 255, 0.1)',
	            boxShadow: '0 0 20px rgba(0, 0, 0, 0.3)'
	          }, _ref3[_theme.media.lessThan('small')] = smallScreenBottomBarStyles, _ref3),
	          onClick: this._openNavMenu,
	          role: 'button',
	          tabIndex: 0 },
	        Glamor.createElement(
	          _Container2.default,
	          null,
	          Glamor.createElement(
	            'div',
	            {
	              css: (_ref4 = {
	                display: 'flex',
	                flexDirection: 'row',
	                alignItems: 'center',
	                height: 60
	              }, _ref4[_theme.media.between('medium', 'large')] = {
	                height: 50
	              }, _ref4[_theme.media.lessThan('small')] = {
	                height: 60,
	                overflow: 'hidden',
	                alignItems: 'flex-start'
	              }, _ref4) },
	            Glamor.createElement(
	              'div',
	              {
	                css: {
	                  width: 20,
	                  height: 20,
	                  alignSelf: 'center',
	                  display: 'flex',
	                  flexDirection: 'column',
	                  color: _theme.colors.brand
	                } },
	              Glamor.createElement(_ChevronSvg2.default, {
	                size: 15,
	                cssProps: {
	                  transform: 'translate(2px, ' + iconOffset + 'px) rotate(180deg)',
	                  transition: 'transform 0.2s ease'
	                }
	              }),
	              Glamor.createElement(_ChevronSvg2.default, {
	                size: 15,
	                cssProps: {
	                  transform: 'translate(2px, ' + (0 - iconOffset) + 'px)',
	                  transition: 'transform 0.2s ease'
	                }
	              })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return StickyResponsiveSidebar;
	}(_react.Component);
	
	exports.default = StickyResponsiveSidebar;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _StickyResponsiveSidebar = __webpack_require__(208);
	
	var _StickyResponsiveSidebar2 = _interopRequireDefault(_StickyResponsiveSidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _StickyResponsiveSidebar2.default; /**
	                                                      * Copyright (c) 2013-present, Facebook, Inc.
	                                                      *
	                                                      * @emails react-core
	                                                      */

	module.exports = exports['default'];

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _reactHelmet = __webpack_require__(54);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * @emails react-core
	 * 
	 */
	
	var defaultDescription = 'A React library for building interactive forms';
	
	var TitleAndMetaTags = function TitleAndMetaTags(_ref) {
	  var title = _ref.title,
	      ogDescription = _ref.ogDescription,
	      ogUrl = _ref.ogUrl;
	
	  return Glamor.createElement(
	    _reactHelmet2.default,
	    { title: title },
	    Glamor.createElement('meta', { property: 'og:title', content: title }),
	    Glamor.createElement('meta', { property: 'og:type', content: 'website' }),
	    ogUrl && Glamor.createElement('meta', { property: 'og:url', content: ogUrl }),
	    Glamor.createElement('meta', { property: 'og:image', content: '/logo-og.png' }),
	    Glamor.createElement('meta', {
	      property: 'og:description',
	      content: ogDescription || defaultDescription
	    })
	  );
	};
	
	exports.default = TitleAndMetaTags;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _TitleAndMetaTags = __webpack_require__(40);
	
	var _TitleAndMetaTags2 = _interopRequireDefault(_TitleAndMetaTags);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TitleAndMetaTags2.default; /**
	                                               * Copyright (c) 2013-present, Facebook, Inc.
	                                               *
	                                               * @emails react-core
	                                               */

	module.exports = exports['default'];

/***/ }),

/***/ 25:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * @providesModule site-constants
	 * 
	 */
	
	// NOTE: We can't just use `location.toString()` because when we are rendering
	// the SSR part in node.js we won't have a proper location.
	var urlRoot = 'https://transformd.com/formatic';
	var version = 'RC-1.0';
	var babelURL = '//unpkg.com/babel-standalone@6.26.0/babel.min.js';
	
	exports.urlRoot = urlRoot;
	exports.version = version;
	exports.babelURL = babelURL;

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChevronSvg = function ChevronSvg(_ref) {
	  var _ref$size = _ref.size,
	      size = _ref$size === undefined ? 10 : _ref$size,
	      _ref$cssProps = _ref.cssProps,
	      cssProps = _ref$cssProps === undefined ? {} : _ref$cssProps;
	  return Glamor.createElement(
	    "svg",
	    {
	      css: cssProps,
	      viewBox: "0 0 926.23699 573.74994",
	      version: "1.1",
	      x: "0px",
	      y: "0px",
	      width: size,
	      height: size },
	    Glamor.createElement(
	      "g",
	      { transform: "translate(904.92214,-879.1482)" },
	      Glamor.createElement("path", {
	        d: "\n          m -673.67664,1221.6502 -231.2455,-231.24803 55.6165,\n          -55.627 c 30.5891,-30.59485 56.1806,-55.627 56.8701,-55.627 0.6894,\n          0 79.8637,78.60862 175.9427,174.68583 l 174.6892,174.6858 174.6892,\n          -174.6858 c 96.079,-96.07721 175.253196,-174.68583 175.942696,\n          -174.68583 0.6895,0 26.281,25.03215 56.8701,\n          55.627 l 55.6165,55.627 -231.245496,231.24803 c -127.185,127.1864\n          -231.5279,231.248 -231.873,231.248 -0.3451,0 -104.688,\n          -104.0616 -231.873,-231.248 z\n        ",
	        fill: "currentColor"
	      })
	    )
	  );
	}; /**
	    * Copyright (c) 2013-present, Facebook, Inc.
	    *
	    * @emails react-core
	    * 
	    */
	
	exports.default = ChevronSvg;
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExternalLinkSvg = function ExternalLinkSvg(_ref) {
	  var _ref$cssProps = _ref.cssProps,
	      cssProps = _ref$cssProps === undefined ? {} : _ref$cssProps;
	  return Glamor.createElement(
	    "svg",
	    {
	      x: "0px",
	      y: "0px",
	      viewBox: "0 0 100 100",
	      width: 15,
	      height: 15,
	      css: cssProps },
	    Glamor.createElement("path", {
	      fill: "currentColor",
	      d: "\n      M18.8,85.1h56l0,0c2.2,0,4-1.8,4-4v-32h-8v28h-48v-48h28v-8h-32l0,\n      0c-2.2,0-4,1.8-4,4v56C14.8,83.3,16.6,85.1,18.8,85.1z\n    "
	    }),
	    Glamor.createElement("polygon", {
	      fill: "currentColor",
	      points: "\n      45.7,48.7 51.3,54.3 77.2,28.5 77.2,37.2 85.2,37.2 85.2,14.9 62.8,\n      14.9 62.8,22.9 71.5,22.9\n      "
	    })
	  );
	}; /**
	    * Copyright (c) 2013-present, Facebook, Inc.
	    *
	    * @emails react-core
	    */
	
	exports.default = ExternalLinkSvg;
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * Copyright (c) 2013-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * @emails react-core
	                                                                                                                                                                                                                                                                   */
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _theme = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MetaTitle = function MetaTitle(_ref) {
	  var children = _ref.children,
	      title = _ref.title,
	      _ref$cssProps = _ref.cssProps,
	      cssProps = _ref$cssProps === undefined ? {} : _ref$cssProps,
	      _ref$onDark = _ref.onDark,
	      onDark = _ref$onDark === undefined ? false : _ref$onDark;
	  return Glamor.createElement(
	    'div',
	    {
	      css: _extends({
	        color: onDark ? _theme.colors.subtleOnDark : _theme.colors.subtle,
	        fontSize: 14,
	        fontWeight: 700,
	        lineHeight: 3,
	        textTransform: 'uppercase',
	        letterSpacing: '0.08em'
	      }, cssProps) },
	    children
	  );
	};
	
	exports.default = MetaTitle;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * Copyright (c) 2013-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * @emails react-core
	                                                                                                                                                                                                                                                                   */
	
	var _Container = __webpack_require__(13);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Flex = __webpack_require__(16);
	
	var _Flex2 = _interopRequireDefault(_Flex);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _theme = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationFooter = function NavigationFooter(_ref) {
	  var _ref2;
	
	  var next = _ref.next,
	      prev = _ref.prev,
	      location = _ref.location;
	
	  return Glamor.createElement(
	    'div',
	    {
	      css: {
	        background: _theme.colors.dark,
	        color: _theme.colors.white,
	        paddingTop: 50,
	        paddingBottom: 50
	      } },
	    Glamor.createElement(
	      _Container2.default,
	      null,
	      Glamor.createElement(
	        _Flex2.default,
	        {
	          type: 'ul',
	          halign: 'space-between',
	          css: (_ref2 = {}, _ref2[_theme.media.between('small', 'medium')] = {
	            paddingRight: 240
	          }, _ref2[_theme.media.between('large', 'largerSidebar')] = {
	            paddingRight: 280
	          }, _ref2[_theme.media.between('largerSidebar', 'sidebarFixed', true)] = {
	            paddingRight: 380
	          }, _ref2) },
	        Glamor.createElement(
	          _Flex2.default,
	          { basis: '50%', type: 'li' },
	          prev && Glamor.createElement(
	            'div',
	            null,
	            Glamor.createElement(
	              SecondaryLabel,
	              null,
	              'Previous article'
	            ),
	            Glamor.createElement(
	              'div',
	              {
	                css: {
	                  paddingTop: 10
	                } },
	              Glamor.createElement(
	                PrimaryLink,
	                { location: location, to: prev },
	                linkToTitle(prev)
	              )
	            )
	          )
	        ),
	        next && Glamor.createElement(
	          _Flex2.default,
	          {
	            halign: 'flex-end',
	            basis: '50%',
	            type: 'li',
	            css: {
	              textAlign: 'right'
	            } },
	          Glamor.createElement(
	            'div',
	            null,
	            Glamor.createElement(
	              SecondaryLabel,
	              null,
	              'Next article'
	            ),
	            Glamor.createElement(
	              'div',
	              {
	                css: {
	                  paddingTop: 10
	                } },
	              Glamor.createElement(
	                PrimaryLink,
	                { location: location, to: next },
	                linkToTitle(next)
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	NavigationFooter.propTypes = {
	  next: _propTypes2.default.string,
	  prev: _propTypes2.default.string
	};
	
	exports.default = NavigationFooter;
	
	
	var linkToTitle = function linkToTitle(link) {
	  return link.replace(/-/g, ' ').replace('.html', '');
	};
	
	var PrimaryLink = function PrimaryLink(_ref3) {
	  var _ref4;
	
	  var children = _ref3.children,
	      to = _ref3.to,
	      location = _ref3.location;
	
	  // quick fix
	  // TODO: replace this with better method of getting correct full url
	  var updatedUrl = location && location.pathname.replace(/\/[^/]+\.html/, '/' + to) || to;
	  return Glamor.createElement(
	    _gatsbyLink2.default,
	    {
	      css: (_ref4 = {
	        display: 'inline',
	        textTransform: 'capitalize',
	        borderColor: _theme.colors.subtle,
	        transition: 'border-color 0.2s ease',
	        fontSize: 30,
	        borderBottomWidth: 1,
	        borderBottomStyle: 'solid'
	
	      }, _ref4[_theme.media.lessThan('large')] = {
	        fontSize: 24
	      }, _ref4[_theme.media.size('xsmall')] = {
	        fontSize: 16
	      }, _ref4[':hover'] = {
	        borderColor: _theme.colors.white
	      }, _ref4),
	      to: updatedUrl },
	    children
	  );
	};
	
	var SecondaryLabel = function SecondaryLabel(_ref5) {
	  var children = _ref5.children;
	  return Glamor.createElement(
	    'div',
	    {
	      css: _extends({
	        color: _theme.colors.brand
	      }, _theme.fonts.small) },
	    children
	  );
	};
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _NavigationFooter = __webpack_require__(216);
	
	var _NavigationFooter2 = _interopRequireDefault(_NavigationFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _NavigationFooter2.default; /**
	                                               * Copyright (c) 2013-present, Facebook, Inc.
	                                               *
	                                               * @emails react-core
	                                               */

	module.exports = exports['default'];

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Section = __webpack_require__(125);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2013-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the CC-BY-4.0 license found
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * in the LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @emails react-core
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var ScrollSyncSection = function (_Component) {
	  _inherits(ScrollSyncSection, _Component);
	
	  function ScrollSyncSection(props, context) {
	    _classCallCheck(this, ScrollSyncSection);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.state = {
	      activeItemId: '',
	      itemTopOffsets: []
	    };
	
	    _this.calculateItemTopOffsets = _this.calculateItemTopOffsets.bind(_this);
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    return _this;
	  }
	
	  ScrollSyncSection.prototype.componentDidMount = function componentDidMount() {
	    this.calculateItemTopOffsets();
	
	    window.addEventListener('resize', this.handleResize);
	    window.addEventListener('scroll', this.handleScroll);
	  };
	
	  ScrollSyncSection.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('resize', this.handleResize);
	    window.removeEventListener('scroll', this.handleScroll);
	  };
	
	  ScrollSyncSection.prototype.calculateItemTopOffsets = function calculateItemTopOffsets() {
	    var section = this.props.section;
	
	
	    var itemIds = _getItemIds(section.items);
	    this.setState({
	      itemTopOffsets: _getElementTopOffsetsById(itemIds)
	    });
	  };
	
	  ScrollSyncSection.prototype.handleResize = function handleResize() {
	    this.calculateItemTopOffsets();
	    this.handleScroll();
	  };
	
	  ScrollSyncSection.prototype.handleScroll = function handleScroll() {
	    var itemTopOffsets = this.state.itemTopOffsets;
	
	    var item = itemTopOffsets.find(function (itemTopOffset, i) {
	      var nextItemTopOffset = itemTopOffsets[i + 1];
	      if (nextItemTopOffset) {
	        return window.scrollY >= itemTopOffset.offsetTop && window.scrollY < nextItemTopOffset.offsetTop;
	      }
	      return window.scrollY >= itemTopOffset.offsetTop;
	    });
	    this.setState({
	      activeItemId: item ? item.id : ''
	    });
	  };
	
	  ScrollSyncSection.prototype.render = function render() {
	    var activeItemId = this.state.activeItemId;
	
	    return Glamor.createElement(_Section2.default, _extends({ isScrollSync: true, activeItemId: activeItemId }, this.props));
	  };
	
	  return ScrollSyncSection;
	}(_react.Component);
	
	var _getItemIds = function _getItemIds(items) {
	  return items.map(function (item) {
	    var subItemIds = [];
	    if (item.subitems) {
	      subItemIds = item.subitems.map(function (subitem) {
	        return subitem.id;
	      });
	    }
	    return [item.id].concat(subItemIds);
	  }).reduce(function (prev, current) {
	    return prev.concat(current);
	  });
	};
	
	var _getElementTopOffsetsById = function _getElementTopOffsetsById(ids) {
	  return ids.map(function (id) {
	    var element = document.getElementById(id);
	    if (!element) {
	      return null;
	    }
	    return {
	      id: id,
	      offsetTop: element.offsetTop
	    };
	  }).filter(function (item) {
	    return item;
	  });
	};
	
	exports.default = ScrollSyncSection;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _theme = __webpack_require__(5);
	
	var _isItemActive = __webpack_require__(224);
	
	var _isItemActive2 = _interopRequireDefault(_isItemActive);
	
	var _MetaTitle = __webpack_require__(42);
	
	var _MetaTitle2 = _interopRequireDefault(_MetaTitle);
	
	var _ChevronSvg = __webpack_require__(124);
	
	var _ChevronSvg2 = _interopRequireDefault(_ChevronSvg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Section = function Section(_ref) {
	  var _ref2, _ref3, _ref4;
	
	  var activeItemId = _ref.activeItemId,
	      createLink = _ref.createLink,
	      isActive = _ref.isActive,
	      isScrollSync = _ref.isScrollSync,
	      location = _ref.location,
	      onLinkClick = _ref.onLinkClick,
	      onSectionTitleClick = _ref.onSectionTitleClick,
	      section = _ref.section;
	  return Glamor.createElement(
	    'div',
	    null,
	    Glamor.createElement(
	      'button',
	      {
	        css: {
	          cursor: 'pointer',
	          backgroundColor: 'transparent',
	          border: 0,
	          marginTop: 10
	        },
	        onClick: onSectionTitleClick },
	      Glamor.createElement(
	        _MetaTitle2.default,
	        {
	          cssProps: (_ref2 = {}, _ref2[_theme.media.greaterThan('small')] = {
	            color: isActive ? _theme.colors.text : _theme.colors.subtle,
	
	            ':hover': {
	              color: _theme.colors.text
	            }
	          }, _ref2) },
	        section.title,
	        Glamor.createElement(_ChevronSvg2.default, {
	          cssProps: (_ref3 = {
	            marginLeft: 7,
	            transform: isActive ? 'rotateX(180deg)' : 'rotateX(0deg)',
	            transition: 'transform 0.2s ease'
	
	          }, _ref3[_theme.media.lessThan('small')] = {
	            display: 'none'
	          }, _ref3)
	        })
	      )
	    ),
	    Glamor.createElement(
	      'ul',
	      {
	        css: (_ref4 = {
	          marginBottom: 10
	
	        }, _ref4[_theme.media.greaterThan('small')] = {
	          display: isActive ? 'block' : 'none'
	        }, _ref4) },
	      section.items.map(function (item) {
	        return Glamor.createElement(
	          'li',
	          {
	            key: item.id,
	            css: {
	              marginTop: 5
	            } },
	          createLink({
	            isActive: isScrollSync ? activeItemId === item.id : (0, _isItemActive2.default)(location, item),
	            item: item,
	            location: location,
	            onLinkClick: onLinkClick,
	            section: section
	          }),
	          item.subitems && Glamor.createElement(
	            'ul',
	            { css: { marginLeft: 20 } },
	            item.subitems.map(function (subitem) {
	              return Glamor.createElement(
	                'li',
	                { key: subitem.id },
	                createLink({
	                  isActive: isScrollSync ? activeItemId === subitem.id : (0, _isItemActive2.default)(location, subitem),
	                  item: subitem,
	                  location: location,
	                  onLinkClick: onLinkClick,
	                  section: section
	                })
	              );
	            })
	          )
	        );
	      })
	    )
	  );
	}; /**
	    * Copyright (c) 2013-present, Facebook, Inc.
	    *
	    * @emails react-core
	    */
	
	exports.default = Section;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Flex = __webpack_require__(16);
	
	var _Flex2 = _interopRequireDefault(_Flex);
	
	var _Section = __webpack_require__(125);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _ScrollSyncSection = __webpack_require__(218);
	
	var _ScrollSyncSection2 = _interopRequireDefault(_ScrollSyncSection);
	
	var _theme = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2013-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @emails react-core
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var Sidebar = function (_Component) {
	  _inherits(Sidebar, _Component);
	
	  function Sidebar(props, context) {
	    _classCallCheck(this, Sidebar);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.state = {
	      activeSection: props.defaultActiveSection
	    };
	    return _this;
	  }
	
	  Sidebar.prototype.render = function render() {
	    var _ref,
	        _this2 = this;
	
	    var _props = this.props,
	        closeParentMenu = _props.closeParentMenu,
	        createLink = _props.createLink,
	        enableScrollSync = _props.enableScrollSync,
	        location = _props.location,
	        sectionList = _props.sectionList;
	    var activeSection = this.state.activeSection;
	
	
	    var SectionComponent = enableScrollSync ? _ScrollSyncSection2.default : _Section2.default;
	
	    return Glamor.createElement(
	      _Flex2.default,
	      {
	        type: 'nav',
	        direction: 'column',
	        halign: 'stretch',
	        css: (_ref = {
	          width: '100%',
	          paddingLeft: 20,
	          position: 'relative'
	
	        }, _ref[_theme.media.greaterThan('largerSidebar')] = {
	          paddingLeft: 40
	        }, _ref[_theme.media.lessThan('small')] = {
	          paddingBottom: 100
	        }, _ref) },
	      sectionList.map(function (section, index) {
	        return Glamor.createElement(SectionComponent, {
	          createLink: createLink,
	          isActive: activeSection === section || sectionList.length === 1,
	          key: index,
	          location: location,
	          onLinkClick: closeParentMenu,
	          onSectionTitleClick: function onSectionTitleClick() {
	            return _this2._toggleSection(section);
	          },
	          section: section
	        });
	      })
	    );
	  };
	
	  Sidebar.prototype._toggleSection = function _toggleSection(section) {
	    this.setState(function (state) {
	      return {
	        activeSection: state.activeSection === section ? null : section
	      };
	    });
	  };
	
	  return Sidebar;
	}(_react.Component);
	
	exports.default = Sidebar;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Sidebar = __webpack_require__(219);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Sidebar2.default; /**
	                                      * Copyright (c) 2013-present, Facebook, Inc.
	                                      *
	                                      * @emails react-core
	                                      */

	module.exports = exports['default'];

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _MarkdownPage = __webpack_require__(207);
	
	var _MarkdownPage2 = _interopRequireDefault(_MarkdownPage);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createLink = __webpack_require__(222);
	
	var _sectionList = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Docs = function Docs(_ref) {
	  var data = _ref.data,
	      location = _ref.location;
	  return Glamor.createElement(_MarkdownPage2.default, {
	    createLink: _createLink.createLinkDocs,
	    location: location,
	    markdownRemark: data.markdownRemark,
	    sectionList: _sectionList.sectionListDocs,
	    titlePostfix: ' - Formatic'
	  });
	}; /**
	    * Copyright (c) 2013-present, Facebook, Inc.
	    *
	    * @emails react-core
	    */
	
	Docs.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	// eslint-disable-next-line no-undef
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = Docs;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	exports.createLinkTutorial = exports.createLinkDocs = exports.createLinkCommunity = exports.createLinkBlog = undefined;
	
	var _activeLinkBefore; /**
	                        * Copyright (c) 2013-present, Facebook, Inc.
	                        *
	                        * @emails react-core
	                        * 
	                        */
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ExternalLinkSvg = __webpack_require__(60);
	
	var _ExternalLinkSvg2 = _interopRequireDefault(_ExternalLinkSvg);
	
	var _slugify = __webpack_require__(82);
	
	var _slugify2 = _interopRequireDefault(_slugify);
	
	var _theme = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createLinkBlog = function createLinkBlog(_ref) {
	  var isActive = _ref.isActive,
	      item = _ref.item,
	      section = _ref.section;
	
	  return Glamor.createElement(
	    _gatsbyLink2.default,
	    { css: [linkCss, isActive && activeLinkCss], to: item.id },
	    isActive && Glamor.createElement('span', { css: activeLinkBefore }),
	    item.title
	  );
	};
	
	var createLinkCommunity = function createLinkCommunity(_ref2) {
	  var isActive = _ref2.isActive,
	      item = _ref2.item,
	      section = _ref2.section;
	
	  if (item.href) {
	    return Glamor.createElement(
	      'a',
	      { css: [linkCss], href: item.href, target: '_blank', rel: 'noopener' },
	      item.title,
	      Glamor.createElement(_ExternalLinkSvg2.default, {
	        cssProps: {
	          verticalAlign: -2,
	          display: 'inline-block',
	          marginLeft: 5,
	          color: _theme.colors.subtle
	        }
	      })
	    );
	  }
	  return createLinkDocs({
	    isActive: isActive,
	    item: item,
	    section: section
	  });
	};
	
	var createLinkDocs = function createLinkDocs(_ref3) {
	  var isActive = _ref3.isActive,
	      item = _ref3.item,
	      section = _ref3.section;
	
	  return Glamor.createElement(
	    _gatsbyLink2.default,
	    {
	      css: [linkCss, isActive && activeLinkCss],
	      to: (0, _slugify2.default)(item.id, section.directory) },
	    isActive && Glamor.createElement('span', { css: activeLinkBefore }),
	    item.title
	  );
	};
	
	var createLinkTutorial = function createLinkTutorial(_ref4) {
	  var isActive = _ref4.isActive,
	      item = _ref4.item,
	      onLinkClick = _ref4.onLinkClick,
	      section = _ref4.section;
	
	  return Glamor.createElement(
	    _gatsbyLink2.default,
	    {
	      css: [linkCss, isActive && activeLinkCss],
	      onClick: onLinkClick,
	      to: item.href },
	    isActive && Glamor.createElement('span', { css: activeLinkBefore }),
	    item.title
	  );
	};
	
	var activeLinkCss = {
	  fontWeight: 700
	};
	
	var activeLinkBefore = (_activeLinkBefore = {
	  width: 4,
	  height: 25,
	  borderLeft: '4px solid ' + _theme.colors.brand,
	  paddingLeft: 16,
	  position: 'absolute',
	  left: 0,
	  marginTop: -3
	
	}, _activeLinkBefore[_theme.media.greaterThan('largerSidebar')] = {
	  left: 15
	}, _activeLinkBefore);
	
	var linkCss = {
	  color: _theme.colors.text,
	  display: 'inline-block',
	  borderBottom: '1px solid transparent',
	  transition: 'border 0.2s ease',
	  marginTop: 5,
	
	  '&:hover': {
	    color: _theme.colors.subtle
	  }
	};
	
	exports.createLinkBlog = createLinkBlog;
	exports.createLinkCommunity = createLinkCommunity;
	exports.createLinkDocs = createLinkDocs;
	exports.createLinkTutorial = createLinkTutorial;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _siteConstants = __webpack_require__(25);
	
	exports.default = function (slug) {
	  return slug == null ? null : _siteConstants.urlRoot + '/' + slug.replace(/^\//, '');
	}; /**
	    * Copyright (c) 2013-present, Facebook, Inc.
	    *
	    * @emails react-core
	    * 
	    */

	module.exports = exports['default'];

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _slugify = __webpack_require__(82);
	
	var _slugify2 = _interopRequireDefault(_slugify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Helper method to locate the section containing the current URL/path.
	 * This method specifically works with the nav_*.yml format.
	 */
	
	var findSectionForPath = function findSectionForPath(pathname, sections) {
	  var activeSection = void 0;
	  var slugId = pathname.split('/').slice(-1)[0];
	
	  sections.forEach(function (section) {
	    var match = section.items.some(function (item) {
	      return slugId === (0, _slugify2.default)(item.id) || item.subitems && item.subitems.some(function (subitem) {
	        return slugId === (0, _slugify2.default)(subitem.id);
	      });
	    });
	    if (match) {
	      activeSection = section;
	    }
	  });
	
	  return activeSection;
	}; /**
	    * Copyright (c) 2013-present, Facebook, Inc.
	    *
	    * @emails react-core
	    * 
	    */
	
	exports.default = findSectionForPath;
	module.exports = exports['default'];

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _slugify = __webpack_require__(82);
	
	var _slugify2 = _interopRequireDefault(_slugify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var toAnchor = function toAnchor() {
	  var href = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  var index = href.indexOf('#');
	  return index >= 0 ? href.substr(index) : '';
	};
	
	// TODO Account for redirect_from URLs somehow; they currently won't match.
	// This comment should not be true anymore since we're using 300 redirects
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * @emails react-core
	 * 
	 */
	
	var isItemActive = function isItemActive(location, item) {
	  if (location.hash) {
	    if (item.href) {
	      return location.hash === toAnchor(item.href);
	    }
	  } else if (item.id.includes('html')) {
	    return location.pathname.includes(item.id);
	  }
	  var slugId = location.pathname.split('/').slice(-1)[0];
	  return slugId === (0, _slugify2.default)(item.id);
	};
	
	exports.default = isItemActive;
	module.exports = exports['default'];

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.sectionListDocs = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * Copyright (c) 2013-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * @emails react-core
	                                                                                                                                                                                                                                                                   * 
	                                                                                                                                                                                                                                                                   */
	
	// $FlowExpectedError
	
	
	var _nav = __webpack_require__(117);
	
	var _nav2 = _interopRequireDefault(_nav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sectionListDocs = _nav2.default.map(function (item) {
	  return _extends({}, item, {
	    directory: 'docs'
	  });
	});
	
	exports.sectionListDocs = sectionListDocs;

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _slugify = __webpack_require__(536);
	
	var _slugify2 = _interopRequireDefault(_slugify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (string, directory) {
	  var filename = (0, _slugify2.default)(string) + '.html';
	
	  return directory ? '/' + directory + '/' + filename : filename;
	}; /**
	    * Copyright (c) 2013-present, Facebook, Inc.
	    *
	    * @emails react-core
	    * 
	    */

	module.exports = exports['default'];

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addString = function addString(list, string) {
	  return list.push(Glamor.createElement(
	    'span',
	    { key: list.length + '-' + string },
	    string
	  ));
	}; /**
	    * Copyright (c) 2013-present, Facebook, Inc.
	    *
	    * @emails react-core
	    * 
	    */
	
	var toCommaSeparatedList = function toCommaSeparatedList(array, renderCallback) {
	  if (array.length <= 1) {
	    return array.map(renderCallback);
	  }
	
	  var list = [];
	
	  array.forEach(function (item, index) {
	    if (index === array.length - 1) {
	      addString(list, array.length === 2 ? ' and ' : ', and ');
	      list.push(renderCallback(item, index));
	    } else if (index > 0) {
	      addString(list, ', ');
	      list.push(renderCallback(item, index));
	    } else {
	      list.push(renderCallback(item, index));
	    }
	  });
	
	  return list;
	};
	
	exports.default = toCommaSeparatedList;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-docs-js-cd82e05cbb3eb3fea175.js